'use strict';

customerZone

.service('shopProvider', ['$http', 'config', 'errorCode', function($http, config, errorCode){
    this.getShops = function(){
        return $http.get(config.baseUrl + '/data/shops.json')
            .then(function(results){
                return results.data;
            }, unwrapError);
    };

    /**
     * Unwrap given error and map fields if the error contains some using the given mapping.
     */
    var unwrapError = function(response){
        if (response.status <= 0 || response.status === 408)
            throw errorCode.wrap(errorCode.HTTP_CONNECTION_ERROR);
        else if (response.status === 429) {
            throw errorCode.wrap(errorCode.REQUEST_THROTTLED, response.data);
        }
        else if (Math.floor(response.status/100) === 4) {
            throw errorCode.wrap(errorCode.CLIENT_ERROR, response.data);
        }
        else {
            throw errorCode.wrap(errorCode.SERVER_ERROR, response.data);
        }
    };
}])

.service('addressResolver', ['$http', '$q', function($http, $q){

    /**
     * Resolve an addres to a coordinates object
     */
    this.resolve = function(address, bounds){
        if (!address) return $q.reject();
        var deferred = $q.defer();
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({address: address, region: 'be'}, function (results, state) {
            var result = firstResult(results, state);
            if (result && inBounds(result, bounds))
                deferred.resolve({
                    lat: result.geometry.location.lat(),
                    lng: result.geometry.location.lng()
                });
            else
                deferred.reject();
        });
        return deferred.promise;
    };

    var firstResult = function(results, state){
        if (state !== google.maps.GeocoderStatus.OK)
            return null;
        if (results.length === 0)
            return null;
        return results[0];
    };

    var inBounds = function(result, bounds){
        var boundsPoly = new google.maps.Polygon({paths: bounds});
        return google.maps.geometry.poly.containsLocation(result.geometry.location, boundsPoly);
    };

}]);

